import $ from 'jquery';
// import Swiper from 'swiper';
import { Functions } from '../../../helpers';
import { Component } from '../../../component';

/* global Swiper */
export class Slider extends Component {
	constructor( context ) {
		super( context );

		this.namespace = 'c-slider';
		this.classes = {
			element: `${ this.namespace }`,
			container: `${ this.namespace }__container`,
		};
		this.slide = {
		};
		this.$element = $( `.js-${ this.classes.container }` );
		this.instances = [];
	}

    setup() {
		const self = this;

		$.each( this.$element, ( index, el ) => {
            const $el = $( el );
			if ( ! $el.length ) {
				return;
			}

            let params = $el.data( 'params' );
			if ( ! params ) {
				return;
			}

			params = $.extend( {}, params, {
				on: {
					init: function() {
						const container = $( this.$el );

						container.addClass( 'swiper-slides-' + params.slidesPerView );

						self.check_slides( this );
					},
				},
			} );

			const sliderInstance = new Swiper( el, params );
			const syncWithId = params.syncWithId || '';
			const $rel = syncWithId ? $( syncWithId ) : null;

			if ( $rel && $rel.length ) {
				sliderInstance.thumbs.swiper = new Swiper( syncWithId, params );
			}

			this.instances.push( sliderInstance );
		} );
	}

	check_slides( swiper ) {
		if ( ! Functions.objectLength( swiper ) ) {
			return;
		}

		const container = $( swiper.$el );
		// Do not hide arrows controls if loop is true
		if ( container.hasClass( 'js-swiper--not-hide-if-many-slides' ) || swiper.params.loop ) {
			return;
		}

        const slides = $( swiper.slides ).not( '.swiper-slide-duplicate' ).length;
        const arrowsContainer = container.parent().find( '.swiper-button-prev, .swiper-button-next' );

		if ( swiper.params.slidesPerView >= slides ) {
			if ( arrowsContainer.length ) {
				arrowsContainer.hide();
			}

			swiper.detachEvents();
		}
	}
}
